import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import Spacer from "./spacer"

const TwoImage = ({ firstImage, firstCaption, secondImage, secondCaption }) => {
  return (
    <>
    <Spacer/>
      <div className='story--twoImage grid ml60 p40'>
        <div className=''>
          <div className='overflow w-100 max-450 '>
            <GatsbyImage image={firstImage?.gatsbyImageData} alt='' className='cover' />
          </div>
          <div className='mt10'>
            <p className='small m0'>Pictured</p>
            <span className='small orange'>{firstCaption}</span>
          </div>
        </div>

        <div className='flex flex-column align-end'>
          <div className='overflow w-100 max-300 m-mwa'>
            <GatsbyImage image={secondImage?.gatsbyImageData} alt='' className='cover' />
          </div>
          <div className='max-300 w-100 mt10 m-mwa'>
            <p className='small m0'>Pictured</p>
            <span className='small orange'>{secondCaption}</span>
          </div>
        </div>
      </div>
      <Spacer/>
    </>
  )
}

export default TwoImage
